import React, { useState, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

import "./Faqs.css";

const FAQs = () => {
  const [showAllQuestions, setShowAllQuestions] = useState(false);
  const [FAQs, setFAQs] = useState([]);
  const questions = showAllQuestions ? FAQs : FAQs.slice(0, 6);
  const getAllFaqs = async () => {
    const faqsRes = await fetch(
      `${process.env.ADC_API_URL}/adc-faqs?populate=*&sort=id:asc`
    );
    const faqsData = await faqsRes.json();
    setFAQs(faqsData?.data);
  };

  useEffect(() => {
    getAllFaqs();
  }, []);

  return (
    <section className="bg-slate-100 py-16">
      <div className="text-center mb-[35px]">
        <h2 className="text-[40px] text-[#1E2144] font-bold">FAQs</h2>
      </div>
      <div className="max-w-[600px] lg:max-w-[880px] mx-auto px-4 tab:px-0">
        {questions.map((faq, index) => (
          <Accordion
            className="mb-8 !bg-white !rounded-lg !shadow-none overflow-hidden"
            key={index}
          >
            <AccordionSummary
              className="!py-[22px] !ps-[46px] !pe-[14px] text-xl md:text-[24px] font-semibold m-0 relative"
              expandIcon={<ExpandMoreIcon className="!text-3xl !font-light" />}
              sx={{
                "& .MuiAccordionSummary-content": {
                  margin: "0 !important",
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                  position: "absolute",
                  left: "9px",
                },
              }}
            >
              {faq?.attributes?.question}
            </AccordionSummary>
            <AccordionDetails className="!ps-[46px] pt-0 pb-10 text-lg font-light answer">
              <BlocksRenderer content={faq?.attributes?.answer} />
            </AccordionDetails>
          </Accordion>
        ))}
        <div className="flex justify-end items-end">
          {!showAllQuestions && (
            <button
              className="bg-sky-800 text-white font-bold py-2 px-6 rounded transition hover:bg-sky-900"
              onClick={() => setShowAllQuestions(true)}
            >
              View All FAQ's
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
